import { c as _c } from "react-compiler-runtime";
import { useState, useMemo, useRef, useEffect, useId } from 'react';
import { CellSelectionEffects } from '../../cellSelection/components/CellSelectionEffects';
import { Provider } from 'react-redux';
import { createStore } from '../../redux/createStore';
import { StoreContext } from '../../redux/storeContext';
import { createWidthsStore } from '../../redux/createWidthsStore';
import { createSelectionStore } from '../../redux/createSelectionStore';
import { createCellSelectionStore } from '../../redux/createCellSelectionStore';
import { WidthsStoreContext } from '../../redux/widthsStoreContext';
import { SelectionStoreContext } from '../../redux/selectionStoreContext';
import { ProvideCellSelection } from '../../cellSelection/context/CellSelectionContext';
import { EmptyComponent } from '../utils/EmptyComponent';
import { DEFAULT_PAGE_SIZES } from '../../pagination/constants/pageSizes';
import emptyFunction from 'react-utils/emptyFunction';
import Table from './Table';
import { ProvideAuth } from '../../auth/context/AuthContext';
import { DEFAULT_COLUMN_MINIMUM_WIDTH, DEFAULT_COLUMN_WIDTH, MINIMUM_RESIZABLE_COLUMN_WIDTH } from '../constants/sizes';
import { DefaultRowComponent } from './DefaultRowComponent';
import { DefaultTableComponent } from './DefaultTableComponent';
import { ProvideLogger } from '../../logger/context/LoggerContext';
import { ProvideFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { ProvideColumnCallToAction } from '../columnCallToAction/ColumnCallToActionContext';
import { useResolvedColumnCallToAction } from '../columnCallToAction/useResolvedColumnCallToAction';
import DefaultSelectAllComponent from '../../selection/components/DefaultSelectAllComponent';
import { ProvideVirtualization } from '../../virtualization/VirtualizationContext';
import { useAdjustCtaColumnWidth } from '../columnCallToAction/useAdjustCtaColumnWidth';
import { getColumnKey } from '../utils/getColumnKey';
import Raven from 'raven-js';
import { BulkActionsContainerAboveTable } from './BulkActionsContainerAboveTable';
import { infiniteScrollDisabled } from '../../infiniteScroll/config';
import { rightToolbarDisabled } from '../../rightToolbar/config';
import { cellSelectionDisabled, CELL_SELECTION_CONFIG_TYPES, isCellSelectionEnabled } from '../../cellSelection/config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyArray = [];
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';

//we explicitly prevent a column width of 0 - this || is weight bearing over ??
const getMinimumColumnWidth = column => Math.max(column.minimumColumnWidth || DEFAULT_COLUMN_MINIMUM_WIDTH,
// Below MINIMUM_RESIZABLE_COLUMN_WIDTH, users can no longer interact with column resizing and can get stuck with a too-narrow column
column.resizable ? MINIMUM_RESIZABLE_COLUMN_WIDTH : 0);
const TableWrapper = t0 => {
  const $ = _c(124);
  const {
    alternateHeaderLeftSlot: t1,
    BulkActionsComponent: t2,
    canSelectAllRecords: t3,
    columns,
    CustomSelectAllComponent: t4,
    disableScrollReset: t5,
    getRowId,
    hasGate,
    hasScope,
    headerLeftSlot: t6,
    headerRightSlot: t7,
    infiniteScrollConfig: t8,
    isBulkActionsRedesignEnabled: t9,
    isIndexRedesignEnabled: t10,
    loading: t11,
    logger: t12,
    noRowsSlot: t13,
    numberOfFrozenColumns: t14,
    onColumnOrderChange: t15,
    onColumnWidthChange: t16,
    contextMenuConfig,
    columnCallToAction,
    onPageIndexChange: t17,
    onPageSizeChange: t18,
    onSortsChange: t19,
    pageable: t20,
    pageIndex: t21,
    pageSize: t22,
    pageSizes: t23,
    maxVisiblePageButtons,
    paginatorAlignment: t24,
    reorderable: t25,
    resizable: t26,
    rows,
    RowComponent: t27,
    scrollContainerRef,
    selectable: t28,
    selectionStore: externalSelectionStore,
    cellSelectable: t29,
    cellSelectionConfig,
    sortable: t30,
    sorts: t31,
    TableComponent: t32,
    totalRowCount: t33,
    zebraStripe: t34,
    condensed: t35,
    dataDensity,
    enableFullVirtualization: t36,
    onFrozenColumnWidthAlert,
    hasTopBarBorderRadius,
    borderless: t37,
    rightToolbarConfig: t38
  } = t0;
  const alternateHeaderLeftSlot = t1 === undefined ? null : t1;
  const BulkActionsComponent = t2 === undefined ? EmptyComponent : t2;
  const canSelectAllRecords = t3 === undefined ? true : t3;
  const CustomSelectAllComponent = t4 === undefined ? DefaultSelectAllComponent : t4;
  const disableScrollReset = t5 === undefined ? false : t5;
  const headerLeftSlot = t6 === undefined ? null : t6;
  const headerRightSlot = t7 === undefined ? null : t7;
  const infiniteScrollConfig = t8 === undefined ? infiniteScrollDisabled : t8;
  const isBulkActionsRedesignEnabled = t9 === undefined ? false : t9;
  const isIndexRedesignEnabled = t10 === undefined ? false : t10;
  const loading = t11 === undefined ? false : t11;
  const logger = t12 === undefined ? emptyFunction : t12;
  const noRowsSlot = t13 === undefined ? null : t13;
  const numberOfFrozenColumns = t14 === undefined ? 0 : t14;
  const onColumnOrderChange = t15 === undefined ? emptyFunction : t15;
  const onColumnWidthChange = t16 === undefined ? emptyFunction : t16;
  const onPageIndexChange = t17 === undefined ? emptyFunction : t17;
  const onPageSizeChange = t18 === undefined ? emptyFunction : t18;
  const onSortsChange = t19 === undefined ? emptyFunction : t19;
  const pageable = t20 === undefined ? true : t20;
  const pageIndex = t21 === undefined ? 0 : t21;
  const pageSize = t22 === undefined ? DEFAULT_PAGE_SIZES[0] : t22;
  const pageSizes = t23 === undefined ? DEFAULT_PAGE_SIZES : t23;
  const paginatorAlignment = t24 === undefined ? "center" : t24;
  const reorderable = t25 === undefined ? true : t25;
  const resizable = t26 === undefined ? true : t26;
  const RowComponent = t27 === undefined ? DefaultRowComponent : t27;
  const selectable = t28 === undefined ? true : t28;
  const cellSelectable = t29 === undefined ? false : t29;
  const sortable = t30 === undefined ? true : t30;
  const sorts = t31 === undefined ? emptyArray : t31;
  const TableComponent = t32 === undefined ? DefaultTableComponent : t32;
  const totalRowCount = t33 === undefined ? 0 : t33;
  const zebraStripe = t34 === undefined ? false : t34;
  const condensed = t35 === undefined ? true : t35;
  const enableFullVirtualization = t36 === undefined ? false : t36;
  const borderless = t37 === undefined ? false : t37;
  const rightToolbarConfig = t38 === undefined ? rightToolbarDisabled : t38;
  const alreadyLoggedRavenRef = useRef(false);
  const fallbackScrollContainerRef = useRef(null);
  const effectiveScrollContainerRef = scrollContainerRef !== null && scrollContainerRef !== void 0 ? scrollContainerRef : fallbackScrollContainerRef;
  let t39;
  if ($[0] !== columns || $[1] !== reorderable || $[2] !== resizable || $[3] !== sortable) {
    let t40;
    if ($[5] !== reorderable || $[6] !== resizable || $[7] !== sortable) {
      t40 = column => {
        const minimumColumnWidth = getMinimumColumnWidth(column);
        const width = Math.max(column.width || DEFAULT_COLUMN_WIDTH, minimumColumnWidth);
        return Object.assign({}, column, {
          columnNamespace: column.columnNamespace || DEFAULT_NAMESPACE,
          width,
          minimumColumnWidth,
          resizable: column.resizable != null ? column.resizable : resizable,
          reorderable: column.reorderable != null ? column.reorderable : reorderable,
          sortable: column.sortable != null ? column.sortable : sortable
        });
      };
      $[5] = reorderable;
      $[6] = resizable;
      $[7] = sortable;
      $[8] = t40;
    } else {
      t40 = $[8];
    }
    t39 = columns.map(t40);
    $[0] = columns;
    $[1] = reorderable;
    $[2] = resizable;
    $[3] = sortable;
    $[4] = t39;
  } else {
    t39 = $[4];
  }
  const columnsWithDefaults = t39;
  let t40;
  let t41;
  if ($[9] !== columns) {
    t40 = () => {
      for (const column_0 of columns) {
        const minimumColumnWidth_0 = getMinimumColumnWidth(column_0);
        if (column_0.width && column_0.width < minimumColumnWidth_0) {
          const errorExtra = {
            columnName: column_0.columnName,
            columnNamespace: column_0.columnNamespace,
            width: column_0.width,
            minimumColumnWidth: minimumColumnWidth_0
          };
          console.error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users.", errorExtra);
          if (!alreadyLoggedRavenRef.current) {
            Raven.captureException(new Error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users."), {
              extra: {
                errorExtra
              }
            });
            alreadyLoggedRavenRef.current = true;
          }
        }
      }
    };
    t41 = [columns];
    $[9] = columns;
    $[10] = t40;
    $[11] = t41;
  } else {
    t40 = $[10];
    t41 = $[11];
  }
  useEffect(t40, t41);
  let t42;
  if ($[12] !== columnsWithDefaults) {
    t42 = () => createWidthsStore({
      initialWidths: columnsWithDefaults.reduce(_temp, {})
    });
    $[12] = columnsWithDefaults;
    $[13] = t42;
  } else {
    t42 = $[13];
  }
  const [widthsStore] = useState(t42);
  let t43;
  if ($[14] !== columnCallToAction || $[15] !== columnsWithDefaults || $[16] !== widthsStore) {
    t43 = {
      columnCallToAction,
      columnsWithDefaults,
      widthsStore
    };
    $[14] = columnCallToAction;
    $[15] = columnsWithDefaults;
    $[16] = widthsStore;
    $[17] = t43;
  } else {
    t43 = $[17];
  }
  useAdjustCtaColumnWidth(t43);
  let t44;
  if ($[18] !== externalSelectionStore) {
    t44 = () => externalSelectionStore ? null : createSelectionStore();
    $[18] = externalSelectionStore;
    $[19] = t44;
  } else {
    t44 = $[19];
  }
  const [internalSelectionStore] = useState(t44);
  const selectionStore = externalSelectionStore !== null && externalSelectionStore !== void 0 ? externalSelectionStore : internalSelectionStore;
  const [cellSelectionStore] = useState(_temp2);
  const cellSelectionScopeId = useId();
  let t45;
  if ($[20] !== cellSelectable || $[21] !== cellSelectionConfig) {
    t45 = cellSelectionConfig !== null && cellSelectionConfig !== void 0 ? cellSelectionConfig : cellSelectable ? {
      type: CELL_SELECTION_CONFIG_TYPES.CELL_SELECTION_ENABLED
    } : cellSelectionDisabled;
    $[20] = cellSelectable;
    $[21] = cellSelectionConfig;
    $[22] = t45;
  } else {
    t45 = $[22];
  }
  const resolvedCellSelectionConfig = t45;
  let t46;
  if ($[23] !== resolvedCellSelectionConfig) {
    t46 = isCellSelectionEnabled(resolvedCellSelectionConfig);
    $[23] = resolvedCellSelectionConfig;
    $[24] = t46;
  } else {
    t46 = $[24];
  }
  const cellSelectionEnabled = t46;
  const [store] = useState(_temp3);
  let t47;
  if ($[25] !== sorts) {
    t47 = sorts.map(_temp4);
    $[25] = sorts;
    $[26] = t47;
  } else {
    t47 = $[26];
  }
  const sortsWithDefaults = t47;
  const shouldShowBulkActionsContainerAboveTable = isBulkActionsRedesignEnabled && isIndexRedesignEnabled;
  let t48;
  if ($[27] !== columnCallToAction || $[28] !== columnsWithDefaults || $[29] !== numberOfFrozenColumns || $[30] !== rows) {
    t48 = {
      columnCallToAction,
      columnsWithDefaults,
      rows,
      numberOfFrozenColumns
    };
    $[27] = columnCallToAction;
    $[28] = columnsWithDefaults;
    $[29] = numberOfFrozenColumns;
    $[30] = rows;
    $[31] = t48;
  } else {
    t48 = $[31];
  }
  const resolvedColumnCallToAction = useResolvedColumnCallToAction(t48);
  let t49;
  if ($[32] !== cellSelectionEnabled || $[33] !== columnsWithDefaults || $[34] !== effectiveScrollContainerRef || $[35] !== getRowId || $[36] !== rows) {
    t49 = cellSelectionEnabled && /*#__PURE__*/_jsx(CellSelectionEffects, {
      columns: columnsWithDefaults,
      rows: rows,
      getRowId: getRowId,
      scrollContainerRef: effectiveScrollContainerRef
    });
    $[32] = cellSelectionEnabled;
    $[33] = columnsWithDefaults;
    $[34] = effectiveScrollContainerRef;
    $[35] = getRowId;
    $[36] = rows;
    $[37] = t49;
  } else {
    t49 = $[37];
  }
  let t50;
  if ($[38] !== BulkActionsComponent || $[39] !== canSelectAllRecords || $[40] !== getRowId || $[41] !== isBulkActionsRedesignEnabled || $[42] !== isIndexRedesignEnabled || $[43] !== rows || $[44] !== shouldShowBulkActionsContainerAboveTable || $[45] !== totalRowCount) {
    t50 = shouldShowBulkActionsContainerAboveTable && /*#__PURE__*/_jsx(BulkActionsContainerAboveTable, {
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      getRowId: getRowId,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      rows: rows,
      totalRowCount: totalRowCount
    });
    $[38] = BulkActionsComponent;
    $[39] = canSelectAllRecords;
    $[40] = getRowId;
    $[41] = isBulkActionsRedesignEnabled;
    $[42] = isIndexRedesignEnabled;
    $[43] = rows;
    $[44] = shouldShowBulkActionsContainerAboveTable;
    $[45] = totalRowCount;
    $[46] = t50;
  } else {
    t50 = $[46];
  }
  let t51;
  if ($[47] !== BulkActionsComponent || $[48] !== CustomSelectAllComponent || $[49] !== RowComponent || $[50] !== TableComponent || $[51] !== alternateHeaderLeftSlot || $[52] !== borderless || $[53] !== canSelectAllRecords || $[54] !== columnsWithDefaults || $[55] !== condensed || $[56] !== dataDensity || $[57] !== disableScrollReset || $[58] !== effectiveScrollContainerRef || $[59] !== enableFullVirtualization || $[60] !== getRowId || $[61] !== hasTopBarBorderRadius || $[62] !== headerLeftSlot || $[63] !== headerRightSlot || $[64] !== infiniteScrollConfig || $[65] !== isBulkActionsRedesignEnabled || $[66] !== isIndexRedesignEnabled || $[67] !== loading || $[68] !== maxVisiblePageButtons || $[69] !== noRowsSlot || $[70] !== numberOfFrozenColumns || $[71] !== onColumnOrderChange || $[72] !== onColumnWidthChange || $[73] !== onFrozenColumnWidthAlert || $[74] !== onPageIndexChange || $[75] !== onPageSizeChange || $[76] !== onSortsChange || $[77] !== pageIndex || $[78] !== pageSize || $[79] !== pageSizes || $[80] !== pageable || $[81] !== paginatorAlignment || $[82] !== reorderable || $[83] !== resizable || $[84] !== rightToolbarConfig || $[85] !== rows || $[86] !== selectable || $[87] !== sortable || $[88] !== sortsWithDefaults || $[89] !== totalRowCount || $[90] !== zebraStripe) {
    t51 = /*#__PURE__*/_jsx(Table, {
      alternateHeaderLeftSlot: alternateHeaderLeftSlot,
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      scrollContainerRef: effectiveScrollContainerRef,
      columns: columnsWithDefaults,
      condensed: condensed,
      dataDensity: dataDensity,
      CustomSelectAllComponent: CustomSelectAllComponent,
      disableScrollReset: disableScrollReset,
      enableFullVirtualization: enableFullVirtualization,
      getRowId: getRowId,
      headerLeftSlot: headerLeftSlot,
      headerRightSlot: headerRightSlot,
      infiniteScrollConfig: infiniteScrollConfig,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      loading: loading,
      noRowsSlot: noRowsSlot,
      numberOfFrozenColumns: numberOfFrozenColumns,
      onColumnOrderChange: onColumnOrderChange,
      onColumnWidthChange: onColumnWidthChange,
      onFrozenColumnWidthAlert: onFrozenColumnWidthAlert,
      onPageIndexChange: onPageIndexChange,
      onPageSizeChange: onPageSizeChange,
      onSortsChange: onSortsChange,
      pageable: pageable,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageSizes: pageSizes,
      maxVisiblePageButtons: maxVisiblePageButtons,
      paginatorAlignment: paginatorAlignment,
      reorderable: reorderable,
      resizable: resizable,
      RowComponent: RowComponent,
      rows: rows,
      selectable: selectable,
      sorts: sortsWithDefaults,
      sortable: sortable,
      TableComponent: TableComponent,
      totalRowCount: totalRowCount,
      zebraStripe: zebraStripe,
      hasTopBarBorderRadius: hasTopBarBorderRadius,
      borderless: borderless,
      rightToolbarConfig: rightToolbarConfig
    });
    $[47] = BulkActionsComponent;
    $[48] = CustomSelectAllComponent;
    $[49] = RowComponent;
    $[50] = TableComponent;
    $[51] = alternateHeaderLeftSlot;
    $[52] = borderless;
    $[53] = canSelectAllRecords;
    $[54] = columnsWithDefaults;
    $[55] = condensed;
    $[56] = dataDensity;
    $[57] = disableScrollReset;
    $[58] = effectiveScrollContainerRef;
    $[59] = enableFullVirtualization;
    $[60] = getRowId;
    $[61] = hasTopBarBorderRadius;
    $[62] = headerLeftSlot;
    $[63] = headerRightSlot;
    $[64] = infiniteScrollConfig;
    $[65] = isBulkActionsRedesignEnabled;
    $[66] = isIndexRedesignEnabled;
    $[67] = loading;
    $[68] = maxVisiblePageButtons;
    $[69] = noRowsSlot;
    $[70] = numberOfFrozenColumns;
    $[71] = onColumnOrderChange;
    $[72] = onColumnWidthChange;
    $[73] = onFrozenColumnWidthAlert;
    $[74] = onPageIndexChange;
    $[75] = onPageSizeChange;
    $[76] = onSortsChange;
    $[77] = pageIndex;
    $[78] = pageSize;
    $[79] = pageSizes;
    $[80] = pageable;
    $[81] = paginatorAlignment;
    $[82] = reorderable;
    $[83] = resizable;
    $[84] = rightToolbarConfig;
    $[85] = rows;
    $[86] = selectable;
    $[87] = sortable;
    $[88] = sortsWithDefaults;
    $[89] = totalRowCount;
    $[90] = zebraStripe;
    $[91] = t51;
  } else {
    t51 = $[91];
  }
  let t52;
  if ($[92] !== cellSelectionScopeId || $[93] !== cellSelectionStore || $[94] !== resolvedCellSelectionConfig || $[95] !== t49 || $[96] !== t50 || $[97] !== t51) {
    t52 = /*#__PURE__*/_jsxs(ProvideCellSelection, {
      config: resolvedCellSelectionConfig,
      store: cellSelectionStore,
      scopeId: cellSelectionScopeId,
      children: [t49, t50, t51]
    });
    $[92] = cellSelectionScopeId;
    $[93] = cellSelectionStore;
    $[94] = resolvedCellSelectionConfig;
    $[95] = t49;
    $[96] = t50;
    $[97] = t51;
    $[98] = t52;
  } else {
    t52 = $[98];
  }
  let t53;
  if ($[99] !== store || $[100] !== t52) {
    t53 = /*#__PURE__*/_jsx(Provider, {
      store: store,
      context: StoreContext,
      children: t52
    });
    $[99] = store;
    $[100] = t52;
    $[101] = t53;
  } else {
    t53 = $[101];
  }
  let t54;
  if ($[102] !== selectionStore || $[103] !== t53) {
    t54 = /*#__PURE__*/_jsx(Provider, {
      store: selectionStore,
      context: SelectionStoreContext,
      children: t53
    });
    $[102] = selectionStore;
    $[103] = t53;
    $[104] = t54;
  } else {
    t54 = $[104];
  }
  let t55;
  if ($[105] !== t54 || $[106] !== widthsStore) {
    t55 = /*#__PURE__*/_jsx(Provider, {
      store: widthsStore,
      context: WidthsStoreContext,
      children: t54
    });
    $[105] = t54;
    $[106] = widthsStore;
    $[107] = t55;
  } else {
    t55 = $[107];
  }
  let t56;
  if ($[108] !== resolvedColumnCallToAction || $[109] !== t55) {
    t56 = /*#__PURE__*/_jsx(ProvideColumnCallToAction, {
      value: resolvedColumnCallToAction,
      children: t55
    });
    $[108] = resolvedColumnCallToAction;
    $[109] = t55;
    $[110] = t56;
  } else {
    t56 = $[110];
  }
  let t57;
  if ($[111] !== contextMenuConfig || $[112] !== t56) {
    t57 = /*#__PURE__*/_jsx(ProvideFDTContextMenuConfig, {
      contextMenuConfig: contextMenuConfig,
      children: t56
    });
    $[111] = contextMenuConfig;
    $[112] = t56;
    $[113] = t57;
  } else {
    t57 = $[113];
  }
  let t58;
  if ($[114] !== enableFullVirtualization || $[115] !== t57) {
    t58 = /*#__PURE__*/_jsx(ProvideVirtualization, {
      enableFullVirtualization: enableFullVirtualization,
      children: t57
    });
    $[114] = enableFullVirtualization;
    $[115] = t57;
    $[116] = t58;
  } else {
    t58 = $[116];
  }
  let t59;
  if ($[117] !== logger || $[118] !== t58) {
    t59 = /*#__PURE__*/_jsx(ProvideLogger, {
      logger: logger,
      children: t58
    });
    $[117] = logger;
    $[118] = t58;
    $[119] = t59;
  } else {
    t59 = $[119];
  }
  let t60;
  if ($[120] !== hasGate || $[121] !== hasScope || $[122] !== t59) {
    t60 = /*#__PURE__*/_jsx(ProvideAuth, {
      hasScope: hasScope,
      hasGate: hasGate,
      children: t59
    });
    $[120] = hasGate;
    $[121] = hasScope;
    $[122] = t59;
    $[123] = t60;
  } else {
    t60 = $[123];
  }
  return t60;
};
export default TableWrapper;
function _temp(acc, column_1) {
  const width_0 = column_1.width || DEFAULT_COLUMN_WIDTH;
  acc[getColumnKey(column_1.columnNamespace || DEFAULT_NAMESPACE, column_1.columnName)] = width_0;
  return acc;
}
function _temp2() {
  return createCellSelectionStore();
}
function _temp3() {
  return createStore();
}
function _temp4(sort) {
  return Object.assign({}, sort, {
    columnNamespace: sort.columnNamespace != null ? sort.columnNamespace : DEFAULT_NAMESPACE
  });
}